import React, {Component, PropTypes} from "react";

class SectionText extends Component {
	render() {
		return (
			<div>
				<h1>{ this.props.heading }</h1>
				<p>{ this.props.body }</p>
				<div>{ this.props.children }</div>
			</div>
		)
	}
}

SectionText.propTypes = {
	heading: PropTypes.string,
	body: PropTypes.string
}
export default SectionText;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/SectionText.jsx
 **/